"use strict";
/**
 * NexusGUI - 统一导出文件
 * 基于HTML+CSS的简洁UI系统，类似Odin Inspector
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = exports.HorizontalComponent = exports.GroupComponent = exports.ButtonComponent = exports.InfoBoxComponent = exports.SeparatorComponent = exports.LabelComponent = exports.DropdownComponent = exports.ToggleComponent = exports.TextFieldComponent = exports.NexusGUIManager = exports.BaseComponent = exports.NexusGUI = void 0;
// 核心类
var NexusGUI_1 = require("./NexusGUI");
Object.defineProperty(exports, "NexusGUI", { enumerable: true, get: function () { return NexusGUI_1.NexusGUI; } });
var BaseComponent_1 = require("./Components/BaseComponent");
Object.defineProperty(exports, "BaseComponent", { enumerable: true, get: function () { return BaseComponent_1.BaseComponent; } });
Object.defineProperty(exports, "NexusGUIManager", { enumerable: true, get: function () { return BaseComponent_1.NexusGUIManager; } });
// 输入组件
var InputComponents_1 = require("./Components/InputComponents");
Object.defineProperty(exports, "TextFieldComponent", { enumerable: true, get: function () { return InputComponents_1.TextFieldComponent; } });
Object.defineProperty(exports, "ToggleComponent", { enumerable: true, get: function () { return InputComponents_1.ToggleComponent; } });
Object.defineProperty(exports, "DropdownComponent", { enumerable: true, get: function () { return InputComponents_1.DropdownComponent; } });
// 显示组件
var DisplayComponents_1 = require("./Components/DisplayComponents");
Object.defineProperty(exports, "LabelComponent", { enumerable: true, get: function () { return DisplayComponents_1.LabelComponent; } });
Object.defineProperty(exports, "SeparatorComponent", { enumerable: true, get: function () { return DisplayComponents_1.SeparatorComponent; } });
Object.defineProperty(exports, "InfoBoxComponent", { enumerable: true, get: function () { return DisplayComponents_1.InfoBoxComponent; } });
// 按钮组件
var ButtonComponent_1 = require("./Components/ButtonComponent");
Object.defineProperty(exports, "ButtonComponent", { enumerable: true, get: function () { return ButtonComponent_1.ButtonComponent; } });
// 布局组件
var LayoutComponents_1 = require("./Components/LayoutComponents");
Object.defineProperty(exports, "GroupComponent", { enumerable: true, get: function () { return LayoutComponents_1.GroupComponent; } });
Object.defineProperty(exports, "HorizontalComponent", { enumerable: true, get: function () { return LayoutComponents_1.HorizontalComponent; } });
// 默认导出NexusGUI类
var NexusGUI_2 = require("./NexusGUI");
Object.defineProperty(exports, "default", { enumerable: true, get: function () { return NexusGUI_2.NexusGUI; } });
